module.exports = __webpack_public_path__ + "static/media/Argos - Notifications - Alt Cream.af412f65.svg";